import { Clock, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRecentSearches } from "@/hooks/useRecentSearches";

interface Props {
  onPick: (q: string) => void;
}

const RecentSearches = ({ onPick }: Props) => {
  const { recent, clearAll } = useRecentSearches();
  if (!recent.length) return null;
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center text-sm text-muted-foreground">
          <Clock className="h-4 w-4 mr-1" /> Recent searches
        </div>
        <Button variant="ghost" size="sm" onClick={clearAll} className="h-7 text-xs">
          <X className="h-3 w-3 mr-1" /> Clear
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {recent.map((q) => (
          <Button key={q} variant="outline" size="sm" onClick={() => onPick(q)} className="rounded-full">
            {q}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default RecentSearches;
